<li *ngFor="let adempimento of adempimenti ; let i=index">
	<div class="tipo_adempimento">
		<p class="{{getClassNameTipoScadenza(adempimento.tipoScadenza.id)}}">
			{{ adempimento.tipoScadenza.label + (adempimento.motivo?.label ? ' - ' + adempimento.motivo.label : '') }}
			<ng-container *ngIf="adempimento.priorita && adempimento.priorita.label">
				<span class="glyphicon glyphicon-exclamation-sign {{getClassColorTipoPriorita(adempimento.priorita.id)}}"></span>
				<span class="{{ getClassNameTipoPriorita(adempimento.priorita.id) }}">{{adempimento.priorita?.label }}</span>
			</ng-container>
		</p>
		<p>{{adempimento.pubblica ? 'PUBBLICO' : 'PRIVATO'}}</p>
		<div class="data_opzioni scadenze no_margin_right">
			<ul>
				<li>{{ adempimento.dataScadenza | dateformatter:'DD/MM/YYYY HH:mm' }}</li>
				<li *ngIf="viewOption" class="opzioni" appDropdownFocus>
					<a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
						aria-expanded="false">Opzioni
						<span class="glyphicon glyphicon-option-vertical"></span>
					</a>
					<div class="dropdown-menu">
						<ul>
							<li *ngIf="!adempimento.evasa"><span class="glyphicon glyphicon-ok"></span> <a
									href="javascript:void(0)" (click)="evadiAdempimento(adempimento)">Evadi</a></li>
							<li><span class="glyphicon glyphicon-share-alt"></span> <a href="javascript:void(0)"
									(click)="rinviaAdempimento(adempimento)">Rinvia</a></li>
						</ul>
					</div>
				</li>
			</ul>
		</div>
	</div>
	<!-- se non c'è la pratica, è di tipo CDA -->
	<div class="documento white" *ngIf="adempimento.tipoPratica.id">
		<p>
			<a href="javascript:void(0)"
				(click)="goToSezScadenza(adempimento.tipoFascicolo.id,adempimento.tipoPratica.id,adempimento.idFascicolo)">
				{{ adempimento.tipoPratica.descrizione + ' - ' + adempimento.tipoFascicolo.descrizione+ ' - ' +
				adempimento.posizione}}
			</a>

		</p>

	</div>
</li>